import { Injectable, signal } from '@angular/core';

@Injectable({ providedIn: 'root' })
export class SideBarService {
  isOn = signal(false);
  width = signal(0);
}
